<template>
  <VCard class="tw-w-full" padding="5">
    <section class="influencerProfileConditions mainHolder">
      <TitleOrangeBar>
        <template #title>
          <span>{{ $t('influencer.profile.slug.about.conditions') }}</span>
        </template>
      </TitleOrangeBar>
      <span class="preWrap tw-inline-block tw-text-base tw-text-black">{{
        influencer.contest?.conditions || ''
      }}</span>
    </section>
  </VCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import TitleOrangeBar from '~/components/ui/Title/OrangeBar.vue'
import VCard from '~/components/ui/VCard.vue'

import type { Influencer, StatsV3Influencer } from '~/types/influencer'
import type { PropType } from 'vue'

export default defineComponent({
  components: {
    VCard,
    TitleOrangeBar,
  },
  props: {
    influencer: {
      type: Object as PropType<Influencer | StatsV3Influencer>,
      required: true,
    },
  },
})
</script>
